

import React from 'react'
import { Card } from 'react-bootstrap'
import { CardRowItem } from '../../cardRowItem'
import * as E from './checklistCardElements'
import { sagbyoStaticData } from './sagbyoStaticData'
import {
  ICardRowItem,
  IDatablock,
  IStaticDataItem,
} from './proposalInterfaces/cardStaticDataTypes'
import { ICardChecklistItemProps } from './proposalInterfaces/cardCheckListItemProps'
import { ITheme } from 'application/utils/type'


const SagByoFormattedData = (theme: ITheme) => {

    const preparePrefixCard = (data: IStaticDataItem) => {
        if (!!data.prefix) {
            let foo: JSX.Element = (
            <div>
                {data.prefix && (
                <div
                    dangerouslySetInnerHTML={{
                    __html: data.prefix as unknown as string,
                    }}
                ></div>
                )}
            </div>
            )
            return foo
        }
    }


    return sagbyoStaticData.map((card: any) => {
    return {
      cardNumber: card.cardNumber,
      cardHeadingNumber: card.cardHeadingNumber,
      title: card.title,
      hideInPdf: card.hideInPdf,
      prefix: preparePrefixCard(card),
      prefixPdf: card.prefixPdf,
      pdfText: card.pdfText,
      datablocks: card.datablocks.map((db: IDatablock) => {
        return {
          heading: db.heading,
          showIds: db.showIds,
          checklistItems: db.checklistItems.map(
            (ci: ICardChecklistItemProps) => {
              return {
                id: ci.id,
                isChecked: ci.isChecked,
                text: ci.text,
              }
            }
          ),
        }
      }),
    }
  })
}

export default SagByoFormattedData